"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeaderStyle2 = void 0;
var react_1 = __importDefault(require("react"));
var Buttons_1 = require("../../../../Buttons");
var Typo_1 = require("../../../../Typo");
var themes_1 = require("../../../../../themes");
var DisplayIcon_1 = require("../../../../../utils/comps/DisplayIcon");
var styled_1 = require("../../styled");
var greyColor80 = themes_1.colors.greyColor80;
var ModalHeaderStyle2 = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, onClose = _a.onClose, setAnimPos = _a.setAnimPos, initAnimPos = _a.initAnimPos;
    return (react_1.default.createElement(styled_1.StyledModalHeaderStyle2Container, null,
        react_1.default.createElement("div", { style: { position: "absolute", top: "-2.5rem" } },
            react_1.default.createElement(DisplayIcon_1.DisplayIcon, { size: 20, icon: "ModalBulbIcon" })),
        react_1.default.createElement(styled_1.StyledModalHeaderStyle2Title, null,
            react_1.default.createElement(Typo_1.SANS_4_5, { semibold: true, capitalize: true }, title || "title"),
            subtitle ? (react_1.default.createElement(Typo_1.SANS_3_4, { semibold: true, capitalize: true, style: { flexGrow: "1" }, color: greyColor80 }, subtitle)) : null,
            onClose && (react_1.default.createElement(Buttons_1.ButtonGhost, { icon: "X", onClick: function () { return setAnimPos(initAnimPos); } })))));
};
exports.ModalHeaderStyle2 = ModalHeaderStyle2;
